<template>
  <div class="develop">
    <div class="whites" ref="whites"></div>
    <h1>发展历史</h1>
    <div class="main">
      <swiper
        :slides-per-view="3"
        :space-between="0"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
      >
        <swiper-slide v-for="item in DataForm" :key="item.id">
          <div class="box">
            <div class="circle">
              <div class="txt">
                {{ item.homeData }}
                <img :src="require('@/assets/logo.png')" alt="" />
              </div>
              <div class="year">{{ item.homeTime }}</div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="btns">
        <div class="prev" @click="addPage(-1)"></div>
        <div class="nexts" @click="addPage(1)"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import { reactive, defineProps, watch, ref, onMounted, getCurrentInstance } from "vue";

const that = getCurrentInstance().appContext.config.globalProperties;
const whites = ref("");
const useSwiper = ref('');

const props = defineProps({
  InitialIndex: String,
});

watch(
  () => props.InitialIndex,
  () => {
    if (props.InitialIndex == "1") {
      whites.value.style.transform = "scaleX(0)";
    }
  }
);

onMounted(()=>{
  that.$http.homeAll("ASC").then((res) => {
    DataForm.length = 0;
    if (res.code === 200) {
      // console.log(res.data);
      DataForm.push(...res.data);
    } else {
      ElMessage({
        message: res.data,
        type: "warning",
      });
    }
  });
})

let DataForm = reactive([]);

const onSwiper = (swiper) => {
  useSwiper.value = swiper;
};

const onSlideChange = () => {
  console.log("slide change");
};


const addPage = (num) => {
	if (num > 0) {
		useSwiper.value.slideNext();
	} else if (num < 0) {
		useSwiper.value.slidePrev();
	}
}
</script>

<style lang="less" scoped>
.develop {
  box-sizing: border-box;
  height: 100%;
  padding: 80px;

  .whites {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 5;
    background-color: white;
    transition: all 1.5s ease;
  }

  h1 {
    display: inline-block;
    box-sizing: border-box;
    padding: 0px 20px 10px 0;
    border-bottom: 2px solid gray;
  }

  .main {
    width: 100%;
    height: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .btns {
      position: absolute;
      top: 10px;
      right: 10px;
      display: flex;

      .nexts {
        width: 30px;
        height: 30px;
        border-radius: 30px;
        margin: 0 5px;
        cursor: pointer;
        font-size: 18px;
        text-align: center;
        line-height: 30px;
        background: url('@/assets/homes/right.png') no-repeat center / 100% 100%;
      }

      .prev {
        width: 30px;
        height: 30px;
        border-radius: 30px;
        margin: 0 5px;
        cursor: pointer;
        font-size: 18px;
        text-align: center;
        line-height: 30px;
        background: url('@/assets/homes/left.png') no-repeat center / 100% 100%;
      }
    }

    .swiper {
      width: 100%;
      height: 80%;

      .swiper-slide {
        display: flex;
        align-items: center;
        justify-content: center;

        .box {
          width: 100%;
          height: 2px;
          background-color: gray;
          display: flex;
          align-items: center;
          justify-content: center;

          .circle {
            width: 20px;
            height: 20px;
            background-color: gray;
            border-radius: 20px;
            position: relative;

            .txt {
              width: 400px;
              height: 200px;
              position: absolute;
              left: -189px;
              box-shadow: 0 0 10px gray;
              padding: 10px;
              box-sizing: border-box;
              font-size: 25px;
              font-weight: 700;
              border-radius: 20px;

              img {
                width: 80px;
                height: 80px;
                position: absolute;
                bottom: 0;
                right: 0;
                z-index: -1;
              }
            }

            .year {
              width: 150px;
              height: 30px;
              position: absolute;
              left: -70px;
              text-align: center;
              line-height: 30px;
              font-size: 18px;
              font-family: "Courier New", Courier, monospace;
            }
          }
        }

        &:nth-child(odd) .txt {
          top: -210px;
        }

        &:nth-child(even) .txt {
          top: 30px;
        }

        &:nth-child(odd) .year {
          top: 30px;
        }

        &:nth-child(even) .year {
          top: -40px;
        }
      }
    }
  }
}
</style>
